// healthcare serves an object, a JSON string, or a legacy auth row's JSON string of a JSON string (R07-L02).
export const parsePreferences = (value: unknown): Record<string, unknown> | null => {
	let parsed = value;
	for (let depth = 0; depth < 2 && typeof parsed === "string"; depth++) {
		try {
			parsed = JSON.parse(parsed);
		} catch {
			return null;
		}
	}
	return parsed !== null && typeof parsed === "object" && !Array.isArray(parsed) ? (parsed as Record<string, unknown>) : null;
};
